module.exports = "<div class=\"form-box form-response\">\r\n  <div class=\"info-item form-response\">\r\n    <div class=\"info-item-heading\">Upload your whatever file</div>\r\n    <div class=\"info-item-data\">\r\n      <div class=\"item condensed-item\">Page 1.pdf</div>\r\n      <div class=\"item condensed-item\">Page 2.pdf</div>\r\n      <div class=\"item condensed-item\">Page 3.pdf</div>\r\n    </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/field-templates/file/response-view.html
// module id = 3441
// module chunks = 0